import { Role } from '../../common/enums';

export const navbarListItemsTextEnum = {
  //Staff
  DASHBOARD: 'Dashboard',
  ORDER: 'ORDER',
  POS: 'POS',
  WALK_UP: 'Walk Up',
  SETTINGS: 'Preferences',
  INVENTORY: 'Inventory',
  EOD: 'EOD',
  //Admin
  ACCOUNTS: 'Accounts',
  CUSTOMERS: 'Customers',
    PRODUCTS: 'Products',
 // PRODUCT_CATEGORIES: 'Product Categories',
  COMPONENTS: 'Components',
  COMPONENT_TYPES: 'ComponentTypes',
  POPULAR: 'Popular Products',
  SECONDARY_INVENTORY: 'Secondary Inventory',
  REPORTS: 'Reports',
  SITES: 'Sites',
  SUPPLIERS: 'My Suppliers',
  RECEIVING: 'Receive Inventory', // Menu for staff to receive goods
  TRANSFERS: 'Stock Transfers',
  EOD_REPORTS: 'EOD Reports',
  //General
  LOG_OUT: 'Log Out',
};

export const navbarListItemsIconEnum = {
  //Staff
  DASHBOARD: 'HomeIcon',
  POS: 'PointOfSaleIcon',
  ORDER: 'ReceiptIcon',
  WALK_UP: 'WalkUpIcon',
  SETTINGS: 'SettingsIcon',
  INVENTORY: 'InventoryIcon',
  TRANSFERS: 'SyncAltIcon',
  EOD: 'AssessmentIcon',
  //Admin
  ACCOUNTS: 'ManageAccountsIcon',
    CUSTOMERS: 'PersonIcon',
    PRODUCTS: 'ShoppingCartIcon',
    //PRODUCT_CATEGORIES: 'LocalDiningIcon',
  COMPONENTS: 'TapasIcon',
  COMPONENT_TYPES: 'LocalDiningIcon',
  SECONDARY_INVENTORY: 'Inventory2Icon',
  REPORTS: 'AssessmentIcon',
  SITES: 'LocationOnIcon',
  POPULAR: 'GradeIcon',
  SUPPLIERS: 'LocalShippingIcon',
  RECEIVING: 'LocalShippingIcon',
  EOD_REPORTS: 'AssessmentIcon',
  //General
  LOG_OUT: 'LogoutIcon',
};

export type NavbarItemData = {
  text: string;
  icon: string;
  path: string;
  tooltipText: string;
  allowedRoles: Role[];
};

export const navbarMainItems: NavbarItemData[] = [
  {
    text: navbarListItemsTextEnum.DASHBOARD,
    icon: navbarListItemsIconEnum.DASHBOARD,
    path: '/staff/home',
    tooltipText: 'Home',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.ORDER,
    icon: navbarListItemsIconEnum.ORDER,
    path: '/staff/order',
    tooltipText: 'Order',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.POS,
    icon: navbarListItemsIconEnum.POS,
    path: '/staff/pos',
    tooltipText: 'POS',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.WALK_UP,
    icon: navbarListItemsIconEnum.WALK_UP,
    path: '/staff/walkup',
    tooltipText: 'Walk Up',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.CUSTOMERS,
    icon: navbarListItemsIconEnum.CUSTOMERS,
    path: '/staff/customers',
    tooltipText: 'Customers',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },
  {
    text: navbarListItemsTextEnum.INVENTORY,
    icon: navbarListItemsIconEnum.INVENTORY,
    path: '/staff/inventory',
    tooltipText: 'Inventory',
    allowedRoles: [Role.General],
  },
  {
    text: navbarListItemsTextEnum.RECEIVING,
    icon: navbarListItemsIconEnum.RECEIVING,
    tooltipText: 'Receiving',
    path: '/staff/receiving',
    allowedRoles: [Role.General],
  },
  {
    text: navbarListItemsTextEnum.TRANSFERS,
    icon: navbarListItemsIconEnum.TRANSFERS,
    tooltipText: 'Stock Transfers',
    path: '/staff/transfers',
    allowedRoles: [Role.General],
  },
];

export const navbarAdminItems: NavbarItemData[] = [
  {
    text: navbarListItemsTextEnum.SITES,
    icon: navbarListItemsIconEnum.SITES,
    path: '/admin/sites',
    tooltipText: 'Sites',
    allowedRoles: [Role.Admin],
  },
  {
    text: navbarListItemsTextEnum.ACCOUNTS,
    icon: navbarListItemsIconEnum.ACCOUNTS,
    path: '/admin/accounts',
    tooltipText: 'Accounts',
    allowedRoles: [Role.Admin],
  },
  {
    text: navbarListItemsTextEnum.PRODUCTS,
    icon: navbarListItemsIconEnum.PRODUCTS,
    path: '/admin/products',
    tooltipText: 'Products',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
    },
   
    //{
    //    text: navbarListItemsTextEnum.PRODUCT_CATEGORIES,
    //    icon: navbarListItemsIconEnum.PRODUCT_CATEGORIES,
    //    path: '/admin/productcategories',
    //    tooltipText: 'Product Categories',
    //    allowedRoles: [Role.Admin, Role.SiteAdmin],
    //},

  {
    text: navbarListItemsTextEnum.COMPONENT_TYPES,
    icon: navbarListItemsIconEnum.COMPONENT_TYPES,
    path: '/admin/componenttypes',
    tooltipText: 'Component Types',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },
  {
    text: navbarListItemsTextEnum.SUPPLIERS,
    icon: navbarListItemsIconEnum.SUPPLIERS,
    path: '/admin/suppliers',
    tooltipText: 'Suppliers',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },
  {
    text: navbarListItemsTextEnum.POPULAR,
    icon: navbarListItemsIconEnum.POPULAR,
    path: '/admin/popular',
    tooltipText: 'Popular',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },
  {
    text: navbarListItemsTextEnum.SECONDARY_INVENTORY,
    icon: navbarListItemsIconEnum.SECONDARY_INVENTORY,
    path: '/admin/stock-report',
    tooltipText: 'Inventory (Stock Management, Prepared Goods, Inventory and Production)',
    // General staff get a read-only view of the inventory interface (prices hidden).
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.REPORTS,
    icon: navbarListItemsIconEnum.REPORTS,
    path: '/admin/reports',
    tooltipText: 'Reports',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },

  {
    text: navbarListItemsTextEnum.EOD_REPORTS,
    icon: navbarListItemsIconEnum.EOD_REPORTS,
    path: '/admin/eod-reports',
    tooltipText: 'EOD Reports',
    allowedRoles: [Role.Admin, Role.SiteAdmin],
  },
];


export const navbarEndItems: NavbarItemData[] = [
  {
    text: navbarListItemsTextEnum.SETTINGS,
    icon: navbarListItemsIconEnum.SETTINGS,
    path: '/staff/settings',
    tooltipText: 'Settings',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
  {
    text: navbarListItemsTextEnum.LOG_OUT,
    icon: navbarListItemsIconEnum.LOG_OUT,
    path: '/staff/home',
    tooltipText: 'Log Out',
    allowedRoles: [Role.Admin, Role.SiteAdmin, Role.General],
  },
];
